import {getRandomNumber} from "../../util/utils";

export interface ICategoryState {
    items: ICategoriesResponse[]
    fetchCategoriesLoading: boolean
    categoryActionLoading: boolean
}

export interface ICategoriesResponse {
    [key: string]: any

    id: string
    name_en: string
    name_mk: string
    name_al: string
    show_when_empty: boolean
    count: number
}

export const getRandomCategoriesArray = (): ICategoriesResponse[] => {
    const arr: ICategoriesResponse[] = []
    const numElements = getRandomNumber(5, 9)
    for (let i = 0; i < numElements; i++) {
        arr.push(
            {
                id: i.toString(), count: 0, name_en: "", name_mk: "", name_al: "", show_when_empty: false,
            }
        )
    }

    return arr
}
